import { render, staticRenderFns } from "./TeamIndex.vue?vue&type=template&id=3b3feff3"
import script from "./TeamIndex.vue?vue&type=script&lang=js"
export * from "./TeamIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports